<div class="generalPage">
  <div class=" flex-display fullComponent">
    <div class="pr-96px pt-104px print-all-content">
      <div class="pendingheading " tabindex="0">{{copyrightHeader}}</div>

      <div class="content ptr-32" [innerHTML]="copyrightBody" tabindex="0"></div>
      <div class="mt-40px h-20px flex-display" id="clickforinfo" [innerHTML]="clickForInformation" tabindex="0"></div>

    </div>
  </div>
</div>

